import { LogIn } from '../../components/ModalsManager/Modals/LogIn/LogIn';
import { SignInWrapper } from './SignIn.styled';

export const SignIn = () => {
  return (
    <>
      <SignInWrapper>
        <LogIn></LogIn>
      </SignInWrapper>
    </>
  );
};
